import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

type TrackEventFunction = () => void;

export const useLandingPageTracker = (trackEvent: TrackEventFunction): void => {
  const { key: locationKey } = useLocation();
  const isExternalLink = useMemo(() => {
    const referrer = document.referrer;
    const isDirectEntry = referrer && new URL(referrer).origin !== window.location.origin;

    const hasAppNavigation = locationKey !== 'default';
    return Boolean(isDirectEntry || !hasAppNavigation);
  }, []);

  useEffect(() => {
    if (isExternalLink) {
      console.log('Landing from external or no referrer detected, triggering trackEvent');
      trackEvent();
    }
  }, []);
};
